import { ProjectStatus } from '../../models';

export const PRIORITY_LABEL_TO_VALUE: Record<string, number> = {
  Low: 0,
  Medium: 1,
  High: 2,
  Urgent: 3,
};

export const PRIORITY_VALUE_TO_LABEL: Record<number, string> = {
  0: 'Low',
  1: 'Medium',
  2: 'High',
  3: 'Urgent',
};

export const PRIORITY_OPTIONS: string[] = ['Low', 'Medium', 'High', 'Urgent'];

// One column per ProjectStatus, so the board speaks the same vocabulary as the
// status filter, the status pill and the inline status select.
export const KANBAN_COLUMNS: { id: string; title: string }[] = [
  { id: 'col-1', title: ProjectStatus.New },
  { id: 'col-2', title: ProjectStatus.OnHold },
  { id: 'col-3', title: ProjectStatus.InProgress },
  { id: 'col-4', title: ProjectStatus.Completed },
];

export const UNASSIGNED_LABEL_ID = 'Unassigned';

export const DATE_FORMATS = {
  MDY: 'MM/DD/YYYY',
} as const;

export const PILL_COLORS: Record<string, { bg: string; fg: string }> = {
  low: { bg: '#f1f5f9', fg: '#64748b' },
  medium: { bg: '#FEF3D9', fg: '#D4A017' },
  high: { bg: '#ffedd5', fg: '#F3720A' },
  urgent: { bg: '#fee2e2', fg: '#b91c1c' },
};
